// Copyright (c) 2019 Deere & Company

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { getDateFormat } from '../../claims/common';
import { AgGridReact } from 'ag-grid-react';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import PropTypes from 'prop-types';
import NonDeereColumnDefinitions from '../../claims/column-definition-nondeere-view';
import ClaasColumnDefinitions from '../../claims/column-definition-claas-view';
import { WarningAlertBar } from '../../shared/components/alert-bar';
import { connect } from 'react-redux';
import { convertUnixtodate } from '../../shared/services/common-functions';
import { filterEmpty } from '../../shared/services/validator';
import { getFactoryByCode } from '../../app/common/repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';

const rowSelection = 'single';

class NonDeereSearchResultPanel extends Component {

    state = {
        selectedGridRow: {},
        factory: '',
        productSeriesIds: '',
        productSubSeriesIds: '',
        baseCodeIds: '',
        regionCode: '',
        branchIds: [],
        warningAlertOpen: true,
    };

    componentDidMount() {
        // moved from deprecated componentWillMount
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;

        const columnsToBeHide = [];
        const allColumnIds = [];
        const searchViewOption = this.props.searchedOptions;

        if (searchViewOption) {
            if (!searchViewOption.includeComplaintCauseCorrection) {
                columnsToBeHide.push('language', 'complaint', 'cause', 'correction', 'lastClaimNumber');
            }
            if (!searchViewOption.includeRejects) {
                columnsToBeHide.push('claimStatusCode');
            }
            if (!searchViewOption.include17CharacterPin) {
                columnsToBeHide.push('pin.digit17');
            }
            if (!searchViewOption.includeAttachmentCount) {
                columnsToBeHide.push('attachmentCount');
            }
        }

        if (this.columnApi?.setColumnsVisible) {
            this.columnApi.setColumnsVisible(columnsToBeHide, false);
        }

        const columns = this.columnApi?.getAllColumns ? this.columnApi.getAllColumns() : [];

        columns.forEach((column) => {
            allColumnIds.push(column.colId);
        });

        if (this.columnApi?.autoSizeColumns && allColumnIds.length > 0) {
            this.columnApi.autoSizeColumns(allColumnIds, true);
        }

        this.props.updateGridAPI(this.gridApi);
    };

    onSelectionChanged = () => {
        const selectedRows = this.gridApi?.getSelectedRows() || [];
        this.setState({
            selectedGridRow: selectedRows[0] || {},
        });
    };

    onBtExport = () => {
        this.gridApi?.exportDataAsCsv({
            processCellCallback: function (cell) {
                let cellVal = cell.value;

                if (cell.column.colDef.valueFormatter) {
                    cellVal = cellVal ? convertUnixtodate(cellVal) : '';
                }
                return cellVal;
            },
        });
    };

    onModify = () => {
        this.props.onEditSearch();
    };

    onClear = () => {
        this.props.onNewSearch();
    };

    updateState = (propertyName, propertyValue) => {
        this.setState({ [propertyName]: propertyValue });
    };

    getFactoryByCode = (factoryCode) => {
        if (factoryCode && factoryCode !== '-1') {
            getFactoryByCode(factoryCode).then((response) => {
                this.updateState('factory', response.factoryDescription);
            });
        }
    };

    onClaimClick = (element) => {
        const elementName = element?.event?.target?.name;
        if (elementName) {
            this.props.onClaimDetails(element.node.rowIndex);
        }
    };

    getSearchedValue = (ob) => {
        const searchedVal = ob[1];
        const searchedName = ob[0];

        switch (searchedName) {
        case 'factoryCode':
            return this.props.factoryCode
                ? this.props.factoryCode.charAt(0).toUpperCase() + this.props.factoryCode.slice(1)
                : '';
        case 'serialNumber':
            return `${searchedVal.from} - ${searchedVal.to}`;
        case 'buildDate':
        case 'processDate':
        case 'buildMonth':
            return `${getDateFormat(searchedVal.from, searchedName)} - ${getDateFormat(searchedVal.to, searchedName)}`;
        case 'productSeriesIds': return this.state.productSeriesIds;
        case 'productSubSeriesIds': return this.state.productSubSeriesIds;
        case 'baseCodeIds': return this.state.baseCodeIds;
        case 'branchIds': return this.state.branchIds;
        case 'regionCode': return this.state.regionCode;
        case 'factoryClaimTypeIds': return this.state.factoryClaimTypeIds;
        case 'pins':
        case 'pipNumbers':
        case 'claimNumbers':
        case 'engineSerialNumbers':
        case 'partNumbers':
        case 'partNumber':
        case 'supplierId':
        case 'modelCdList':
            return this.searchResultHeader(searchedVal);
        case 'partDescription':
            return searchedVal;
        default:
            return searchedVal ? searchedVal.toString() : '';
        }
    };

    searchResultHeader = (propertyValue) => {
        const arr = filterEmpty(propertyValue);
        return arr.length > 4 ? `${arr.length} selected` : arr.join(', ');
    };

    dismissHandler = () => {
        this.setState({ warningAlertOpen: false });
    };

    render() {
        const claimList = Array.isArray(this.props.claimList) ? this.props.claimList : [];
        const hasValidClaims = claimList.length > 0;

        const factory = this.props.factoryCode?.toLowerCase();
        const columnMap = {
            liebherr: NonDeereColumnDefinitions,
            claas: ClaasColumnDefinitions,
            wirtgen: ClaasColumnDefinitions,
        };
        const columnDefinitions = columnMap[factory] || NonDeereColumnDefinitions;

        const errMessage = 'Limited Results Displayed!!! Please Enter Additional/Narrower Search Criteria to get Full Results.';
        const defaultColDef = { resizable: true };

        const items = this.props.editedInputs
            .filter(item => {
                if (!this.props.searchedLabels[item[0]]) return false;
                const val = this.getSearchedValue(item);
                return val !== null && val !== undefined && val.toString() !== '';
            })
            .map(item => (
                <div key={item[0]} className="header-style">
                    <label>{this.props.searchedLabels[item[0]]}</label>
                    <div className="headerResult-style">
                        <span>{this.getSearchedValue(item)}</span>
                    </div>
                </div>
            ));

        return (
            <section>
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />

                {!hasValidClaims && (
                    <WarningAlertBar alertTitle="Error" dismissHandler={this.dismissHandler}>
                        No claims found. Please refine your search criteria.
                    </WarningAlertBar>
                )}

                {hasValidClaims && claimList.length >= 5000 && this.state.warningAlertOpen && (
                    <WarningAlertBar alertTitle="Warning" dismissHandler={this.dismissHandler}>
                        {errMessage}
                    </WarningAlertBar>
                )}

                <header>
                    <h2 className="page-header">
                        Claim Search - {hasValidClaims ? claimList.length : 0} Results

                        <i
                            className="fa fa-refresh result-page-refesh"
                            aria-hidden="true"
                            onClick={this.props.onSubmit}
                            title="Refresh"
                        />

                        <button className="primary-button" onClick={this.onModify} type="button">
                            <span>Edit Search</span>
                        </button>

                        <button className="primary-button" onClick={this.onClear} type="button">
                            <span>New Search</span>
                        </button>

                        {this.props.callFrom === 'findClaim' && (
                            <div className="downloadwrp">
                                <div className="dropdown">
                                    <button className="report-button" onClick={this.props.onSubmit} type="button">
                                        Download Report
                                    </button>
                                </div>
                            </div>
                        )}
                    </h2>

                    <div className="headerPanel-style">{items}</div>
                </header>

                <main>
                    <section className="search-result-panel">
                        <div className="ag-theme-balham ag-theme-popupbg">
                            {hasValidClaims && (
                                <AgGridReact
                                    columnDefs={columnDefinitions}
                                    defaultColDef={defaultColDef}
                                    rowData={claimList}
                                    onGridReady={this.onGridReady}
                                    rowSelection={rowSelection}
                                    onCellClicked={this.onClaimClick}
                                    onSelectionChanged={this.onSelectionChanged}
                                    popupParent={document.body}
                                    enableCellTextSelection
                                />
                            )}
                        </div>
                    </section>
                </main>
            </section>
        );
    }
}

NonDeereSearchResultPanel.defaultProps = {
    claimList: [],
};

NonDeereSearchResultPanel.propTypes = {
    searchedOptions: PropTypes.object.isRequired,
    factoryCode: PropTypes.string.isRequired,
    claimList: PropTypes.array,
    onEditSearch: PropTypes.func.isRequired,
    onNewSearch: PropTypes.func.isRequired,
    searchedLabels: PropTypes.object.isRequired,
    onClaimDetails: PropTypes.func.isRequired,
    editedInputs: PropTypes.array.isRequired,
    updateGridAPI: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    callFrom: PropTypes.string.isRequired,
    busyCounter: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    busyCounter: showLoadingIndicator(state.application.busyCounter),
});

const mapDispatchToProps = dispatch => ({
    increaseCounter: () => dispatch(busyCounter.increaseBusyCounter()),
    decreaseCounter: () => dispatch(busyCounter.decreaseBusyCounter()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NonDeereSearchResultPanel);